export default __webpack_public_path__ + "static/media/Red_Bull.28f3e048.png";